export default "__VITE_ASSET__C3qYoblS__"